export default class DataHelper {
  static calculateRSI(dataList) {
    let rsi
    let rsiABSEma = 0
    let rsiMaxEma = 0

    for (let i = 0; i < dataList.length; i++) {
      const point = dataList[i]
      const closePrice = point.getClosePrice()

      if (i === 0) {
        rsi = 0
        rsiABSEma = 0
        rsiMaxEma = 0
      } else {
        const Rmax = Math.max(0, closePrice - dataList[i - 1].getClosePrice())
        const RAbs = Math.abs(closePrice - dataList[i - 1].getClosePrice())

        rsiMaxEma = (Rmax + (14 - 1) * rsiMaxEma) / 14
        rsiABSEma = (RAbs + (14 - 1) * rsiABSEma) / 14
        rsi = (rsiMaxEma / rsiABSEma) * 100
      }

      if (i < 13) {
        rsi = 0
      }

      if (isNaN(rsi)) {
        rsi = 0
      }

      point.rsi = rsi
    }
  }

  static calculateKDJ(dataList) {
    let k = 0
    let d = 0

    for (let i = 0; i < dataList.length; i++) {
      const point = dataList[i]
      const closePrice = point.getClosePrice()
      let startIndex = i - 13
      if (startIndex < 0) {
        startIndex = 0
      }

      let max14 = Number.MIN_VALUE
      let min14 = Number.MAX_VALUE

      for (let index = startIndex; index <= i; index++) {
        max14 = Math.max(max14, dataList[index].getHighPrice())
        min14 = Math.min(min14, dataList[index].getLowPrice())
      }

      let rsv = (100 * (closePrice - min14)) / (max14 - min14)

      if (isNaN(rsv)) {
        rsv = 0
      }

      if (i === 0) {
        k = 50
        d = 50
      } else {
        k = (rsv + 2 * k) / 3
        d = (k + 2 * d) / 3
      }

      if (i < 13) {
        point.k = 0
        point.d = 0
        point.j = 0
      } else if (i === 13 || i === 14) {
        point.k = k
        point.d = 0
        point.j = 0
      } else {
        point.k = k
        point.d = d
        point.j = 3 * k - 2 * d
      }
    }
  }

  static calculateWR(dataList) {
    let r
    for (let i = 0; i < dataList.length; i++) {
      const point = dataList[i]
      let startIndex = i - 14
      if (startIndex < 0) {
        startIndex = 0
      }

      let max14 = Number.MIN_VALUE
      let min14 = Number.MAX_VALUE

      for (let index = startIndex; index <= i; index++) {
        max14 = Math.max(max14, dataList[index].getHighPrice())
        min14 = Math.min(min14, dataList[index].getLowPrice())
      }

      if (i < 13) {
        point.r = -10
      } else {
        r = (-100 * (max14 - dataList[i].getClosePrice())) / (max14 - min14)
        if (isNaN(r)) {
          point.r = 0
        } else {
          point.r = r
        }
      }
    }
  }

  static calculateMACD(dataList) {
    let ema12 = 0
    let ema26 = 0
    let dif = 0
    let dea = 0
    let macd = 0

    for (let i = 0; i < dataList.length; i++) {
      const point = dataList[i]
      const closePrice = point.getClosePrice()

      if (i === 0) {
        ema12 = closePrice
        ema26 = closePrice
      } else {
        ema12 = (ema12 * 11) / 13 + (closePrice * 2) / 13
        ema26 = (ema26 * 25) / 27 + (closePrice * 2) / 27
      }

      dif = ema12 - ema26
      dea = (dea * 8) / 10 + (dif * 2) / 10
      macd = (dif - dea) * 2

      point.dif = dif
      point.dea = dea
      point.macd = macd
    }
  }

  static calculateBOLL(dataList) {
    for (let i = 0; i < dataList.length; i++) {
      const point = dataList[i]

      if (i < 19) {
        point.mb = 0
        point.up = 0
        point.dn = 0
      } else {
        const n = 20
        let md = 0

        for (let j = i - n + 1; j <= i; j++) {
          const c = dataList[j].getClosePrice()
          const m = point.getMA20Price()
          const value = c - m
          md += value * value
        }

        md = md / (n - 1)
        md = Math.sqrt(md)

        point.mb = point.getMA20Price()
        point.up = point.mb + 2 * md
        point.dn = point.mb - 2 * md
      }
    }
  }

  static calculateMA(dataList) {
    let ma5 = 0
    let ma10 = 0
    let ma20 = 0
    let ma30 = 0
    let ma60 = 0

    for (let i = 0; i < dataList.length; i++) {
      const point = dataList[i]
      const closePrice = point.getClosePrice()

      ma5 += closePrice
      ma10 += closePrice
      ma20 += closePrice
      ma30 += closePrice
      ma60 += closePrice

      if (i === 4) {
        point.MA5Price = ma5 / 5
      } else if (i >= 5) {
        ma5 -= dataList[i - 5].getClosePrice()
        point.MA5Price = ma5 / 5
      } else {
        point.MA5Price = 0
      }

      if (i === 9) {
        point.MA10Price = ma10 / 10
      } else if (i >= 10) {
        ma10 -= dataList[i - 10].getClosePrice()
        point.MA10Price = ma10 / 10
      } else {
        point.MA10Price = 0
      }

      if (i === 19) {
        point.MA20Price = ma20 / 20
      } else if (i >= 20) {
        ma20 -= dataList[i - 20].getClosePrice()
        point.MA20Price = ma20 / 20
      } else {
        point.MA20Price = 0
      }

      if (i === 29) {
        point.MA30Price = ma30 / 30
      } else if (i >= 30) {
        ma30 -= dataList[i - 30].getClosePrice()
        point.MA30Price = ma30 / 30
      } else {
        point.MA30Price = 0
      }

      if (i === 59) {
        point.MA60Price = ma60 / 60
      } else if (i >= 60) {
        ma60 -= dataList[i - 60].getClosePrice()
        point.MA60Price = ma60 / 60
      } else {
        point.MA60Price = 0
      }
    }
  }

  static calculateVolumeMA(entries) {
    let volumeMa5 = 0
    let volumeMa10 = 0

    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i]

      volumeMa5 += entry.getVolume()
      volumeMa10 += entry.getVolume()

      if (i === 4) {
        entry.MA5Volume = volumeMa5 / 5
      } else if (i > 4) {
        volumeMa5 -= entries[i - 5].getVolume()
        entry.MA5Volume = volumeMa5 / 5
      } else {
        entry.MA5Volume = 0
      }

      if (i === 9) {
        entry.MA10Volume = volumeMa10 / 10
      } else if (i > 9) {
        volumeMa10 -= entries[i - 10].getVolume()
        entry.MA10Volume = volumeMa10 / 10
      } else {
        entry.MA10Volume = 0
      }
    }
  }

  static calculate(dataList) {
    DataHelper.calculateMA(dataList)
    DataHelper.calculateMACD(dataList)
    DataHelper.calculateBOLL(dataList)
    DataHelper.calculateRSI(dataList)
    DataHelper.calculateKDJ(dataList)
    DataHelper.calculateWR(dataList)
    DataHelper.calculateVolumeMA(dataList)
  }
}
